const components = {
  BaseInput: () => import('@/components/atoms/BaseInput'),
  BaseSelect: () => import('@/components/atoms/BaseSelect'),
  BaseRadio: () => import('@/components/atoms/BaseRadio'),
  BaseCheckbox: () => import('@/components/atoms/BaseCheckbox'),
  BaseRatingStars: () => import('@/components/atoms/BaseRatingStars'),
  BaseTextarea: () => import('@/components/atoms/BaseTextarea')
};

export default {
  components,
  data () {
    return {
      fieldTypes: [
        {
          fieldTypeId: '3f92e01b-29e2-4a30-bf33-9df5580ed52c',
          fieldType: [
            'short answer',
            'text',
            'email'
          ],
          componentType: 'BaseInput'
        },
        {
          fieldTypeId: 'fb37bc60-d41e-11de-aeae-37c155d89593',
          fieldType: [
            'password'
          ],
          componentType: 'BasePassword'
        },
        {
          fieldTypeId: '0dd29d42-a6a5-11de-a2f2-222256d89593',
          fieldType: [
            'dropdown',
            'select'
          ],
          componentType: 'BaseSelect'
        },
        {
          fieldTypeId: '903df9b0-a78c-11de-9fc1-db7a56d89593',
          fieldType: [
            'single choice',
            'radio'
          ],
          componentType: 'BaseRadio'
        },
        {
          fieldTypeId: '023f09ac-1445-4bcb-b8fa-ab49f33bd046',
          fieldType: [
            'long answer',
            'textarea'
          ],
          componentType: 'BaseTextarea'
        },
        {
          fieldTypeId: 'fab43f20-a6bf-11de-a28f-9b5755d89593',
          fieldType: [
            'multiple choice'
          ],
          componentType: 'MultipleChoice'
        },
        {
          fieldTypeId: 'd5c0c390-ae9a-11de-a69e-666455d89593',
          fieldType: [
            'checkbox'
          ],
          componentType: 'BaseCheckbox'
        },
        {
          fieldTypeId: 'a72c9df9-3847-47cf-afb8-b86773fd12cd',
          fieldType: [
            'data consent'
          ],
          componentType: 'DataConsent'
        },
        {
          fieldTypeId: 'f8b4c3b8-af28-11de-9dd8-ef5956d89593',
          fieldType: [
            'date'
          ],
          componentType: 'Date'
        },
        {
          fieldTypeId: 'e3fbf6c4-f46c-495e-aff8-4b3c227b4a98',
          fieldType: [
            'title and description'
          ],
          componentType: 'TitleAndDescription'
        },
        {
          fieldTypeId: 'da206cae-1c52-434e-b21a-4a7c198af877',
          fieldType: [
            'hidden'
          ],
          componentType: 'Hidden'
        }
      ]
    }
  }
};
